'use strict';

export const formatTopicsPerCategory = ({ fields, sys }) => {
  if (!sys || !fields) return {};

  const { name, description, noAccess, exclusiveAccess } = fields;

  return {
    id: sys.id,
    name,
    description,
    noAccess,
    exclusiveAccess,
  };
};

export const formatCategory = ({ sys, fields }) => {
  if (!sys || !fields) return {};

  const image = fields.categoryImage && fields.categoryImage.fields.file.url;

  const { name, categoryDescription } = fields;
  const { id } = sys;
  const topics = _.map(fields.topics, topic => formatTopicsPerCategory(topic)); // eslint-disable-line no-undef

  return {
    id,
    name,
    topics,
    image,
    categoryDescription,
  };
};

export const formatCategories = categories => categories
  ? _.map(categories, category => formatCategory(category)) // eslint-disable-line no-undef
  : [];

export const formatCopyright = ({ sys, fields }) => {
  if (!sys || !fields) return {};

  const { text } = fields;
  const { id } = sys;

  return {
    id,
    text,
  };
};

// Topics
// ##################################################
export const formatTopic = ({ fields, sys }) => {
  if (!sys || !fields) return {};

  const { name, description, excerpt, richText, author, source, copyright, noAccess, sidebarImage } = fields;
  const { id } = sys;

  return {
    id,
    name,
    description,
    excerpt,
    richText,
    author,
    source,
    copyright: copyright ? formatCopyright(copyright) : null,
    noAccess,
    sidebarImage,
  };
};

export const formatTopics = topics => topics ? _.map(topics, topic => formatTopic(topic)) : []; // eslint-disable-line no-undef

// Articles per topic section
// ##################################################
export const formatArticleList = ({ fields, sys }) => {
  if (!sys || !fields) return {};

  const { name, sub, externalUrl, excerpt, type, topics, order_articles } = fields;
  const { id } = sys;

  return {
    id,
    name,
    sub,
    excerpt,
    type,
    externalUrl,
    order: order_articles,
    topics: formatTopics(topics),
  };
};

export const formatArticlesPerTopic = topics => topics
  ? _.map(topics, topic => formatArticleList(topic)) // eslint-disable-line no-undef
  : [];

// Single article
// ##################################################
export const formatRelatedArticles = ({ sys, fields }) => {
  if (!sys || !fields) return {};

  const { name, sub, type, excerpt, link, topics, externalUrl } = fields;
  const { id } = sys;

  return {
    id,
    name,
    sub,
    type,
    excerpt,
    link,
    externalUrl,
    topicId: topics && topics.length ? topics[0].sys.id : '',
  };
};

export const formatArticle = ({ fields, sys }) => {
  if (!sys || !fields) return {};

  const { id } = sys;
  const { name, sub, related, richText, author, tags, source, reviews, copyright } = fields;

  return {
    id,
    name,
    sub,
    related: _.map(_.filter(related, article => article.fields), article => formatRelatedArticles(article) ), // eslint-disable-line no-undef
    richText,
    author,
    tags,
    source,
    reviews,
    copyright: copyright ? formatCopyright(copyright) : null,
  };
};



// WEBPACK FOOTER //
// ./client/utils/contentful.js